function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_4",
  "data-name": "Ellipse 4",
  cx: 16,
  cy: 16,
  r: 16,
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Outline",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 16 2 C 12.26045989990234 2 8.744749069213867 3.456249237060547 6.100500106811523 6.100500106811523 C 3.456249237060547 8.744749069213867 2 12.26045989990234 2 16 C 2 19.73954010009766 3.456249237060547 23.2552490234375 6.100500106811523 25.89949989318848 C 8.744749069213867 28.54375076293945 12.26045989990234 30 16 30 C 19.73954010009766 30 23.2552490234375 28.54375076293945 25.89949989318848 25.89949989318848 C 28.54375076293945 23.2552490234375 30 19.73954010009766 30 16 C 30 12.26045989990234 28.54375076293945 8.744749069213867 25.89949989318848 6.100500106811523 C 23.2552490234375 3.456249237060547 19.73954010009766 2 16 2 M 16 0 C 24.8365592956543 0 32 7.163440704345703 32 16 C 32 24.8365592956543 24.8365592956543 32 16 32 C 7.163440704345703 32 0 24.8365592956543 0 16 C 0 7.163440704345703 7.163440704345703 0 16 0 Z",
  stroke: "none",
  fill: "#fff"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "User",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_292",
  "data-name": "Gruppe 292",
  transform: "translate(3.879 4.849)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2",
  "data-name": "Ellipse 2",
  transform: "translate(5.818)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.303,
  cy: 5.818,
  rx: 6.303,
  ry: 5.818,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.303,
  cy: 5.818,
  rx: 5.803,
  ry: 5.318,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_3",
  "data-name": "Ellipse 3",
  transform: "translate(0 10.667)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.121,
  cy: 11.636,
  rx: 12.121,
  ry: 11.636,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.121,
  cy: 11.636,
  rx: 11.621,
  ry: 11.136,
  fill: "none"
}))));

function SvgImgBenutzerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "IMG_Benutzer-Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBenutzerIcon);
export default __webpack_public_path__ + "static/media/IMG_Benutzer-Icon.89003249a06716daf64771327071e356.svg";
export { ForwardRef as ReactComponent };